import { StyleSheet, View } from 'react-native';

import { Button, IconClose, Text } from '@fhs/ui';
import {
  PICKUP_TIME_SELECTOR_CLOSE_BUTTON,
  PICKUP_TIME_SELECTOR_HEADING,
} from '@fhs-legacy/frontend/src/utils/test-ids';

export default function PickupTimeModalHeading({ onClose }: { onClose(): void }) {
  return (
    <View testID={PICKUP_TIME_SELECTOR_HEADING} style={styles.header}>
      <Text.Heading type="two">Schedule Pickup</Text.Heading>
      <Button testID={PICKUP_TIME_SELECTOR_CLOSE_BUTTON} type="unstyled" onPress={onClose}>
        <Button.Icon>
          <IconClose fontWeight={700} />
        </Button.Icon>
      </Button>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    margin: 28,
  },
  heading: {
    marginVertical: 8,
    marginHorizontal: 16,
  },
});
